import Head from "next/head";
import React from "react";
import Link from "next/link";
import Meta from "../../components/Meta";

const Privacy = () => {
  return (
    <div>
      <Meta title="Privacy Policy" />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Privacy Policy --> */}
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Privacy Policy
            </h1>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <h2 className="text-base">Last Updated: June 3, 2023</h2>
              <p>
                Blue Quanta LLC ("Company," "we," or "us") operates the
                bluequanta.io website (the "Website"). This Privacy Policy
                explains how we collect, use, disclose, and safeguard your
                personal information when you visit the Website.
              </p>
              <h2>1. Information We Collect</h2>
              <p>
                a. Personal Information: We may collect personal information
                that you voluntarily provide to us, such as your name, email
                address, phone number, and any other information you provide
                when contacting us or submitting inquiries through the Website.
              </p>
              <p>
                b. Usage Data: We may also collect non-personal information
                about your use of the Website, such as your IP address, browser
                type, operating system, and browsing preferences.
              </p>
              <h2>2. Use of Information</h2>
              <p>a. We may use the information we collect to:</p>
              <p>i. Provide, maintain, and improve the Website;</p>
              <p>ii. Respond to your inquiries and provide customer support;</p>
              <p>
                iii. Send you promotional and marketing communications, if you
                have opted-in to receive such communications;
              </p>
              <p>
                iv. Monitor and analyze trends, usage, and activities on the
                Website;
              </p>
              <p>
                v. Detect, investigate, and prevent fraudulent or unauthorized
                activities.
              </p>
              <h2>3. Disclosure of Information</h2>
              <p>
                a. We may share your personal information with third parties in
                the following circumstances:
              </p>
              <p>
                i. With service providers who assist us in operating and
                maintaining the Website;
              </p>
              <p>
                ii. With our affiliates and subsidiaries for the purposes
                described in this Privacy Policy;
              </p>
              <p>
                iii. When required by law or in response to a valid legal
                request.
              </p>
              <h2>4. Data Security</h2>
              <p>
                a. We take reasonable measures to protect your personal
                information from unauthorized access, alteration, disclosure, or
                destruction. However, please note that no method of transmission
                over the internet or electronic storage is completely secure.
              </p>
              <h2>5. Third-Party Websites</h2>
              <p>
                a. The Website may contain links to third-party websites or
                resources. We are not responsible for the privacy practices or
                content of such third-party websites. We encourage you to review
                the privacy policies of those websites.
              </p>
              <h2>6. Children's Privacy</h2>
              <p>
                a. The Website is not intended for use by individuals under the
                age of 13. We do not knowingly collect personal information from
                children under 13. If you believe we may have collected
                information from a child under 13, please contact us, and we
                will promptly delete such information.
              </p>
              <h2>7. Your Choices</h2>
              <p>
                a. You may opt-out of receiving promotional emails from us by
                following the instructions provided in those emails. Please note
                that even if you opt-out, we may still send you non-promotional
                communications, such as administrative emails related to your
                use of the Website.
              </p>
              <h2>8. Updates to the Privacy Policy</h2>
              <p>
                a. We reserve the right to update or change this Privacy Policy
                at any time. We will post the updated Privacy Policy on the
                Website with the "Last Updated" date.
              </p>
              <h2>9. Contact Us</h2>
              <p>
                a. If you have any questions, concerns, or requests regarding
                this Privacy Policy, please contact us through our{" "}
                <Link href="/contact">contact form</Link>.
              </p>
            </div>
          </div>
        </section>
        {/* <!-- end Privacy Policy --> */}
      </div>
    </div>
  );
};

export default Privacy;
